import { createStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import { FontIcon, withBaseProps } from '@topconagriculture/react-components';
import cn from 'classnames';
import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import withAuth0 from '../../hocs/withAuth0';
const BORDER_THICKNESS = 6;
const globalStyles = ({ isImpersonating }) => {
    return (isImpersonating &&
        makeStyles({
            '@global': {
                html: {
                    padding: BORDER_THICKNESS,
                },
            },
        }));
};
const styles = (theme) => createStyles({
    borderElement: {
        position: 'fixed',
        zIndex: 99998,
        backgroundColor: theme.color.error.main,
    },
    borderLeft: {
        left: 0,
        width: BORDER_THICKNESS,
        height: '100%',
    },
    borderRight: {
        right: 0,
        width: BORDER_THICKNESS,
        height: '100%',
    },
    borderBottom: {
        bottom: 0,
        height: BORDER_THICKNESS,
        width: '100%',
    },
    borderTop: {
        top: 0,
        left: 0,
        right: 0,
        height: BORDER_THICKNESS,
    },
    textElement: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        position: 'fixed',
        zIndex: 99999,
        top: 0,
        left: '35%',
        width: '30%',
        height: 30,
        backgroundColor: theme.color.error.main,
        padding: 5,
        borderRadius: '0 0 10px 10px',
        verticalAlign: 'middle',
    },
    warningText: {
        color: theme.color.font.light,
        fontSize: theme.font.size.mediumSmall,
        fontWeight: theme.font.weight.bold,
    },
    closeButton: {
        marginLeft: theme.space.margin.default,
        fontWeight: theme.font.weight.bold,
    },
});
const ImpersonationIndicator = (props) => {
    const { classes, auth, t, closeImpersonationHandler } = props;
    const { isImpersonating } = auth;
    let globalCss = {};
    if (isImpersonating) {
        const customStyle = isImpersonating && globalStyles({ isImpersonating });
        globalCss = customStyle();
    }
    const newClasses = { ...classes, ...globalCss };
    return isImpersonating ? (React.createElement("div", null,
        React.createElement("div", { className: newClasses.textElement },
            React.createElement("p", { className: newClasses.warningText }, t('common:impersonation_active')),
            React.createElement(FontIcon, { iconName: "circle-cancel", size: 14, className: newClasses.closeButton, onClick: closeImpersonationHandler, testId: 'stop-impersonate' })),
        React.createElement("div", { className: cn(newClasses.borderLeft, newClasses.borderElement) }),
        React.createElement("div", { className: cn(newClasses.borderRight, newClasses.borderElement) }),
        React.createElement("div", { className: cn(newClasses.borderTop, newClasses.borderElement) }),
        React.createElement("div", { className: cn(newClasses.borderBottom, newClasses.borderElement) }))) : null;
};
export default compose(withBaseProps({ styles }), withAuth0, withHandlers({
    closeImpersonationHandler: ({ auth }) => () => {
        auth.stopImpersonating();
    },
}))(ImpersonationIndicator);
//# sourceMappingURL=ImpersonationIndicator.js.map